import React from 'react';
import PropTypes from 'prop-types';
import NavigationRowExpandImg from './styled/NavigationRowExpandImg';
import NavigationRow from './NavigationRow';
import { useUrlBuilder } from '../../../hooks/useUrlBuilder';
import VerticalSpacer from '../../UI/VerticalSpacer';
import { fontFamilies } from '../../UI/Font';

const NavigationLevel = ({ values, handleLevel, handleBack, level }) => {
  const { localized, withCDN } = useUrlBuilder();
  const { name, children, featuredLabel, featuredDesigners, url } = values;

  return (
    <div>
      {level !== 0 && (
        <>
          <div>
            <span data-cy={`nav-link-back`} className="navigation-back" onClick={() => handleBack(false)}>
              <img src={withCDN('mkt/icon/arrow_left_black.png')} style={{ height: '17px', width: '17px' }} />
              Back
            </span>
          </div>
          {name.toLowerCase() !== 'designers' && (
            <>
              <div className="navigation-section-title">
                <span style={{ color: name.toLowerCase() === 'sale' ? '#F25C5E' : 'black' }}>{name}</span>
              </div>
              <NavigationRow
                text={`all ${name}`}
                href={localized(url)}
                handleClick={() => handleLevel(values, { allCategoryClick: true })}
              />
            </>
          )}
        </>
      )}
      {name.toLowerCase() === 'designers' && (
        <>
          <div style={{ borderBottom: '1px solid #ECEEEF' }} />
          <NavigationRow
            text={'Designers A-Z'}
            href={localized(url)}
            handleClick={() => handleLevel(values, { allCategoryClick: true })}
          />
          <VerticalSpacer height="25px" />
          <div className="navigation-section-title">
            <span>{'Featured designers'}</span>
          </div>
        </>
      )}
      {children.map((curr, index) => (
        <>
          {level === 0 && index === 0 && <div style={{ borderBottom: '1px solid #ECEEEF' }} />}
          <NavigationRow
            key={`${curr.name}_${index}`}
            href={localized(curr.url)}
            text={curr.name}
            handleClick={event => {
              if (curr.children && curr.children.length > 0) {
                event.preventDefault();
              }
              handleLevel(curr);
            }}
          >
            {curr.children && curr.children.length > 0 && (
              <NavigationRowExpandImg src={withCDN('mkt/icon/plus_black.png')} />
            )}
          </NavigationRow>
        </>
      ))}
      {featuredLabel && (
        <>
          <VerticalSpacer height="25px" />
          <div className="navigation-section-title">
            <span>{featuredLabel}</span>
          </div>
        </>
      )}
      {featuredDesigners.map((curr, index) => (
        <NavigationRow key={`${curr.name}_${index}`} text={curr.name} href={localized(curr.url)} />
      ))}
      <style jsx>
        {`
          .navigation-back {
            padding-left: 12px;
            font-size: 15px;
            color: #222222;
            height: 50px;
            display: inline-flex;
            align-items: center;
          }

          .navigation-section-title {
            text-align: center;
            padding: 10px 0;
            border-bottom: 1px solid #eceeef;
          }

          .navigation-section-title > span {
            font-size: 15px;
            font-family: ${fontFamilies.bold};
            color: #222222;
          }
        `}
      </style>
    </div>
  );
};

NavigationLevel.propTypes = {
  values: PropTypes.shape({
    name: PropTypes.string,
    children: PropTypes.array,
    featuredLabel: PropTypes.string,
    featuredDesigners: PropTypes.array,
    url: PropTypes.string,
  }),
  handleLevel: PropTypes.func,
  handleBack: PropTypes.func,
  level: PropTypes.number,
};

export default NavigationLevel;
